import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NodesComponent} from './nodes.component';
import {NodesSummaryComponent} from './nodes-summary/nodes-summary.component';
import {NodesDialogComponent} from './nodes-dialog/nodes-dialog.component';
import {DialogModule} from '../../components/dialog/dialog.module';
import {FormsModule} from '@angular/forms';
import {InfraModule} from 'ac-infra';
import {FlexModule} from '@angular/flex-layout';
import {PipsModule} from '../../pipes/pips.module';
import {ColumnsFilterModule} from '../../components/columns-filter/columns-filter.module';
import {SearchModule} from '../../components/search/search.module';
import {LayoutModule} from '../../components/layout/layout.module';
import { NodesSearchComponent } from './nodes-search/nodes-search.component';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import { NodesThirdPartyDialogComponent } from './nodes-third-party-dialog/nodes-third-party-dialog.component';
import {MaterialModule} from '../../material.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';

@NgModule({
  declarations: [
    NodesComponent,
    NodesSummaryComponent,
    NodesDialogComponent,
    NodesSearchComponent,
    NodesThirdPartyDialogComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
    FormsModule,
    InfraModule,
    FlexModule,
    PipsModule,
    ColumnsFilterModule,
    SearchModule,
    LayoutModule,
    ActionBarModule,
    MaterialModule,
    ArmTableModule
  ]
})
export class NodesModule { }
